import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function ExecuteInstallments() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="depositAmount"
      Lefticon={
        <img src="../../../assets/images/svg/waitingInstallments.svg" />
      }>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_contract_details_execute_installments_title")}
      </p>
    </Pill>
  );
}
